import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "row",
  id: "visit-request"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "row mx-2 my-5" }
const _hoisted_4 = { class: "col-sm-12 col-md-4 order-md-last mb-2" }
const _hoisted_5 = { class: "text-center mb-3" }
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = {
  key: 0,
  class: "text-center mb-2"
}
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "col-sm-12 col-md-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_visit_schedule_form = _resolveComponent("visit-schedule-form")!
  const _component_modal = _resolveComponent("modal")!
  const _component_scenario_card = _resolveComponent("scenario-card")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "text-center mx-auto mb-3 w-75" }, "This visit has been requested for:", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit_request.dates, (date, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: date.id
                }, [
                  _createElementVNode("h4", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.moment(date.local_time).format('MM/DD/YYYY')), 1),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _cache[13] || (_cache[13] = _createElementVNode("small", null, "at", -1)),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.moment(date.local_time).format('h:mm')), 1),
                      _createElementVNode("sup", null, _toDisplayString(_ctx.moment(date.local_time).format('a')), 1)
                    ])
                  ]),
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "or"))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.show_user_data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mb-0" }, "Visit requested by", -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.visit_request.user.name) + " (" + _toDisplayString(_ctx.visit_request.user.email) + ")", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.is_admin && _ctx.learner_type !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("p", null, "Learner Type: " + _toDisplayString(_ctx.learner_type), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.is_learner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-small text-muted" }, "We are in the process of assigning a Standardized Patient to your request.", -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-small text-danger" }, "You will receive a notification of the appointment time from your SP through an SMS Text to your cell phone.", -1)),
                    (!_ctx.show_reschedule)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("button", {
                            class: "btn btn-secondary btn-md w-100 my-2",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showCancelModal && _ctx.showCancelModal(...args)))
                          }, "Cancel Request"),
                          _createElementVNode("button", {
                            class: "btn btn-secondary btn-md w-100 mb-2",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showReschedule && _ctx.showReschedule(...args)))
                          }, "Reschedule Request")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.is_sp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[18] || (_cache[18] = [
                    _createElementVNode("p", null, "A Visit has been requested.", -1)
                  ])))
                : _createCommentVNode("", true),
              (_ctx.is_learner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_ctx.show_reschedule)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_visit_schedule_form, {
                              field: "visit_date_one",
                              "alt-field": "visit_date_two",
                              "start-date": _ctx.start_date,
                              "end-date": _ctx.end_date,
                              "disabled-dates": _ctx.partner_disabled_dates,
                              onUpdateDate: _ctx.setDate,
                              "scenario-id": _ctx.visit_request.scenario_id
                            }, null, 8, ["start-date", "end-date", "disabled-dates", "onUpdateDate", "scenario-id"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary btn-md w-100 mb-2",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showRescheduleModal && _ctx.showRescheduleModal(...args)))
                            }, "Reschedule Visit Request"),
                            _createElementVNode("button", {
                              class: "btn btn-secondary btn-md w-100",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showReschedule && _ctx.showReschedule(...args)))
                            }, "Cancel"),
                            _createVNode(_component_modal, {
                              modelValue: _ctx.reschedule_modal,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reschedule_modal) = $event))
                            }, {
                              header: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Reschedule Visit Request")
                              ])),
                              default: _withCtx(() => [
                                _cache[20] || (_cache[20] = _createElementVNode("p", null, "Are you sure you want to reschedule this request?", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary btn-md float-end",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rescheduleRequest && _ctx.rescheduleRequest(...args)))
                                }, "Reschedule Visit Request")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_modal, {
                      modelValue: _ctx.cancel_modal,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cancel_modal) = $event))
                    }, {
                      header: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode("Cancel Visit Request")
                      ])),
                      default: _withCtx(() => [
                        _createElementVNode("p", null, [
                          _cache[22] || (_cache[22] = _createTextVNode("Are you sure you want to cancel this request? ")),
                          (_ctx.visit_request.payment_amount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Your account will be credited for $" + _toDisplayString((_ctx.visit_request.payment_amount).toFixed(2)) + ". This credit can only be used to reschedule for this scenario.", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-md float-end",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelRequest && _ctx.cancelRequest(...args)))
                        }, "Cancel Visit Request")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.is_sp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[23] || (_cache[23] = _createElementVNode("p", null, "Please review the below dates and approve a selection that is convienent for you.", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit_request.dates, (date) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: date.id,
                            class: "d-block"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "request_date_id",
                              value: date.id,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.request_date_id.value) = $event))
                            }, null, 8, _hoisted_22), [
                              [_vModelRadio, _ctx.form.request_date_id.value]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.moment(date.local_time).format('MM/DD/YY h:mm a')), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-secondary btn-md w-100",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showApproveModal && _ctx.showApproveModal(...args)))
                        }, "Accept")
                      ])
                    ]),
                    _createVNode(_component_modal, {
                      modelValue: _ctx.approve_modal,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.approve_modal) = $event))
                    }, {
                      header: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode("Approve Visit Request")
                      ])),
                      default: _withCtx(() => [
                        _cache[25] || (_cache[25] = _createElementVNode("p", null, "Are you sure you want to approve this request?", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-md float-end",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.approveRequest && _ctx.approveRequest(...args)))
                        }, "Approve Visit Request")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_scenario_card, {
                scenario: _ctx.visit_request.scenario,
                formatted_field_data: _ctx.formatted_field_data
              }, null, 8, ["scenario", "formatted_field_data"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}